export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

export function isIosSafari() {
  const ua = navigator.userAgent;
  const isIos = /iPhone|iPad|iPod/i.test(ua);
  // Include iOS Chrome (CriOS) since it uses WebKit and has same constraints as Safari
  const isSafariOrChrome = /Safari/i.test(ua) && !/FxiOS|EdgiOS/i.test(ua);
  return isIos && isSafariOrChrome;
}
